import { Collapse } from "bootstrap";

export default class GlobalSearch extends HTMLFormElement {

    connectedCallback() {

        this.addEventListener("shown.bs.collapse", () => {
            this.focusElement.focus();
        });

        this.closeBtn.addEventListener("click", () => {

            Collapse.getOrCreateInstance(this).hide();
            this.openerElement.focus();

        });
        
    }

    get openerElement() {
        document.querySelector(`[data-bs-toggle="collapse"][data-bs-target="#${this.id}"]`);
    }

    get focusElement() {
        return document.querySelector(`#${this.dataset.focusElement}`);
    }

    get closeBtn() {
        return this.querySelector(`.btn-close`);
    }

}

customElements.define('global-search', GlobalSearch, { extends: 'form' });